import React from 'react';
import { AlertCircle } from 'lucide-react';

const FaultySensorIndicator = ({ position }) => {
  return (
    <div className="group relative inline-block">
      <AlertCircle 
        size={14} 
        className="text-red-700 inline-block mr-1" 
      />
      <div className="invisible group-hover:visible fixed transform -translate-y-full mt-1
                    w-64 px-2 py-1 text-sm text-white bg-gray-900 rounded-md">
        {position} sensor is currently faulty and excluded from AQI calculations
      </div>
    </div>
  );
};

export default FaultySensorIndicator;